export default "/images/3c0073399b732219c2b1af6b133f6207.png";